import { Edit, AccountBox } from '@mui/icons-material';
import { Dialog, DialogActions, DialogContent, Grid, IconButton } from '@mui/material';
import { FC, useCallback, useEffect, useState } from 'react';
import { ContactDto } from '../../dtos';
import { useUpdateContactMutation } from '../../store/generated/generatedApi';
import { useFailedCreateSnackbar, useSuccessfulCreateSnackbar } from '../CoreLib/library';
import { ContactForm } from '../Forms/ContactForm';
import { ModalSaveCloseFooter, ModalTitle } from '../Modal';
import { useContactForm } from '../Forms/ContactForm/useContactForm';

export interface IContactQuickEditButtonProps {
    onEdit: (newCustomer: ContactDto) => void;
    customerId?: string;
    contact?: ContactDto;
    disabled?: boolean;
}

export const ContactQuickEditButton: FC<IContactQuickEditButtonProps> = ({ onEdit, contact, customerId, disabled }) => {
    const [isModalOpen, setIsModalOpen] = useState(false);
    const [updateContact, { data, isError, isSuccess, reset, isLoading }] = useUpdateContactMutation();
    useSuccessfulCreateSnackbar('Contact', isSuccess, reset);
    useFailedCreateSnackbar('contact', isError, reset);

    const [currentContact, setCurrentContact] = useState<ContactDto>(contact ?? {} as ContactDto);

    const save = useCallback(
        (contact: ContactDto) => {
            updateContact(contact);
            setIsModalOpen(false);
            setCurrentContact(contact);
        },
        [updateContact]
    );

    const cancel = useCallback(() => {
        setIsModalOpen(false);
    }, []);

    const contactFormManager = useContactForm({ save, cancel, initValues: isModalOpen ? contact : undefined, isLoading }, customerId, true);
    const { handleSave, handleCancel } = contactFormManager;

    useEffect(() => {
        if (isSuccess) {
            onEdit(currentContact);
        }
    }, [onEdit, data, isSuccess, currentContact]);

    return (
        <>
            <IconButton onClick={() => setIsModalOpen(true)} color='primary' disabled={disabled}>
                <Edit />
            </IconButton>
            <Dialog open={isModalOpen} fullWidth maxWidth='lg'>
                <ModalTitle icon={<AccountBox sx={{ mr: 1 }} />} title={'Edit Contact'} />
                <DialogContent>
                    <Grid container direction='row' gap={1}>
                        <ContactForm
                            contactFormManager={contactFormManager}
                            isLoading={isLoading}
                        />
                    </Grid>
                </DialogContent>
                <DialogActions sx={{ height: 48 }}>
                    <ModalSaveCloseFooter onSaveClicked={handleSave} onCancelCloseClicked={handleCancel} />
                </DialogActions>
            </Dialog>
        </>
    );
};
